import { createFileRoute, useParams } from '@tanstack/react-router';

import { OrganizationEditScreen } from '@/features/organizations/components/workspace/OrganizationEditScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/organizations/$orgId/edit')({
  beforeLoad: () => {
    requirePermission('org:update');
  },
  component: WorkspaceOrganizationEditRoute,
  staticData: { crumb: 'Edit' },
});

function WorkspaceOrganizationEditRoute() {
  const { orgId } = useParams({ from: '/_staff/admin/workspace/organizations/$orgId/edit' });
  return <OrganizationEditScreen orgId={orgId} />;
}
